const settingsHu = {
    "settings": "Beállítások",
    "group_reservation": {
        "enable": "Csoportos foglalások engedélyezése",
        "show_on_page": "Csoportos foglalási oldal megjelenítése",
        "settings_title": "Csoportos foglalás beállításai",
        "min_group_size": "Minimum csoportméret",
        "max_group_size": "Maximum csoportméret",
        "min_spending": "Minimum fogyasztás (Ft/fő)",
        "max_spending": "Maximum fogyasztás (Ft/fő)",
        "menu_link": "Étlap/menü link",
        "short_desc": "Rövid leírás",
        "long_desc": "Hosszú leírás",
        "confirm_title": "Megerősítés szükséges",
        "confirm_text": "Kérem erősítse meg, hogy megismerte és elfogadja az ÁSZF-ben a csoportos foglalásra vonatkozó részt és tudomásul veszi, hogy a listázó oldalról(reservours.com/csoportos-foglalas) jövő foglalások esetén, 2026.03.31 után foglalási díj vonatkozik az ÁSZF-ben meghatározottak szerint.",
        "accept": "Elfogadom",
        "cancel": "Mégsem"
    },
    "payments": {
        "refund": "Visszatérítés",
    },
    "reservation_settings": {
        "title": "Foglalási beállítások",
        "reservation_system": "Foglalási beállítások",
        "reservation_availability": "Időszakos kapacitáskorlátok",
        "special_approval_rules": "Kötelező jóváhagyási időszakok",
        "reservation_source": "Egyedi foglalási forrás",
        "reservation_labels": "Címkék",
        "reservation_fees": "Foglalási díjak",
        "custom_questions": "Egyedi kérdések",
        "reservation_length_rules": "Foglalási hossz beállítások",
        "reservation_types": "Foglalási típusok",
        "group_offer_packages": "Csoportos csomagok",
        "guest_reviews": "Vendég értékelések",
    },
    "guest_reviews": {
        "info_box": "A vendégértékelések bekapcsolása esetén a rendszerünk automatikusan üzenetet küld minden vendégnek egy nappal a látogatása után.\nSaját üzenet küldési mód esetén lehetősége van a felületen beállítani, milyen üzenetet kap a vendég.\nA ReservOurs kérés mód kiválasztása esetén a rendszerünk emailt küld a vendégeknek, amely a saját értékeléskérő oldalunkra irányítja őket. A leadott értékelések később a Statisztika oldalunkon visszakövethetőek.",
        "enable": "Értékelések kérése a foglalás másnapján",
        "request_mode": "Értékelés kérés módja",
        "own_message": "Saját üzenet",
        "reservours": "ReservOurs",
        "review_structure": "Értékelés felépítése",
        "simple": "Egyszerű",
        "detailed": "Részletes",
        "review_structure_info_simple": "A vendég egyetlen, 1-től 5-ig terjedő skálán értékelheti az élményét.",
        "review_structure_info_detailed": "A vendég külön értékeli az étel minőségét, a kiszolgálást és a hangulatot, mindegyiket 1-től 5-ig terjedő skálán.",
        "text_review_enable": "Szöveges értékelés engedélyezése",
        "review_links_info": "A belső értékelés leadása után, automatikusan megjelenítjük a vendég felé a Google és a Tripadvisor értékelési linket, ha be van állítva. A Google értékelési linkhez csak a Google azonosítót kell megadni.",
        "google_id": "Google ID",
        "google_id_helper": "Megegyezik a Google értékelésekben használt értékkel",
        "google_id_placeholder": "Adja meg a Google Business azonosítót",
        "tripadvisor": "Tripadvisor link",
        "tripadvisor_placeholder": "Adja meg a Tripadvisor linket",
    },
    "custom_questions": {
        "add_new": "Új kérdés hozzáadása",
        "edit": "Kérdés szerkesztése",
        "question_text": "Kérdés szövege",
        "answer_options": "Válaszlehetőségek",
        "add_answer": "Válasz hozzáadása",
        "is_optional": "Opcionális kérdés",
        "no_questions": "Még nincs egyedi kérdés. Adj hozzá egyet a foglalási folyamat bővítéséhez.",
        "optional": "Opcionális",
        "required": "Kötelező",
        "delete_confirm": "Biztosan törlöd ezt a kérdést?",
        "question_type": "Kérdés típusa",
        "type_checkbox": "Jelölőnégyzet",
        "type_dropdown": "Legördülő lista",
        "checkbox_hint": "A vendégnek be kell jelölnie a foglaláskor.",
    },
    "tables_and_rooms": {
        "title": "Asztalok és termek",
        "tables": "Asztalok sorrendje",
        "table_groups": "Asztal csoportok",
        "rooms": "Termek",
        "room_data": "Terem adatok",
        "select_room": "Terem kiválasztása",
        "select_room_placeholder": "Válassz termet",
        "max_standing": "Maximális vendégek száma (álló)",
        "max_seated": "Maximális vendégek száma (ülő)",
        "room_description": "Terem leírása (max 2000 karakter)",
        "table_list_editor": "Asztalok listája",
        "room": "Terem",
        "floorplan_designer": "Asztaltérkép",
        "show_on_group_reservation": "Megjelenítés a csoportos foglalás oldalon",
        "selected_room": "Szerkesztett terem",
        "room_image": "Terem kép",
        "room_has_tables": "Ehhez a teremhez már vannak asztalok rendelve, ezért a törlése nem lehetséges.",
        "delete_room": "Terem törlése",
    },
    "opening_hours_and_blocks": {
        "title": "Nyitvatartás és blokkolások",
        "blocked_times": "Órák blokkolása",
        "room_blocks": "Termek blokkolása",
        "special_dates": "Blokkolás",
        "opening_hours": "Nyitvatartás",
        "shifts": "Műszakok",
        "custom_opening_hours": "Egyedi nyitvatartás",
        "service_break": "Szerviz szünet",
    },
    "account": {
        "title": "Fiók",
    },
    "messages": {
        "title": "Kommunikáció",
        "auto_messages": "Automatikus üzenetek",
        "custom_messages": "Egyedi üzenetek",
        "internal_events": "Belső esemény",
        "reservation_messages": "Foglalási felület üzenet",
        "acceptance_texts": "Elfogadandó szövegek",
        "test_send": "Teszt küldés"
    },
    "restaurant_profile": {
        "title": "Éttermi profil",
    },
    "restaurant_settings": {
        "title": "Étterem beállítások",
        "reservours_info": "ReservOurs linkek",
        "restaurant_info": "Étterem információk",
        "restaurant_images": "Étterem képek",
        "google_reviews": "Google értékelések",
        "tags": {
            "badacsony": "Badacsony",
            "balaton": "Balaton",
            "breakfast": "Reggeli",
            "brunch": "Brunch",
            "burger": "Burger",
            "business-lunch-and-dinner": "Business ebéd és vacsora",
            "cocktail": "Koktél",
            "cozy": "Hangulatos",
            "craft-beer": "Kézműves sör",
            "deli-part": "Déli part",
            "dunakanyar": "Dunakanyar",
            "elegant": "Elegáns",
            "eszaki-part": "Északi part",
            "family-lunch-and-dinner": "Családi ebéd és vacsora",
            "gault-millau": "Gault&Millau",
            "michelin": "Michelin",
            "outdoor": "Kinti",
            "party": "Party",
            "romantic": "Romantikus",
            "wine-tasting": "Borkóstoló",
            "street-kitchen": "Street kitchen",
            "vb2026": "Foci VB 2026 közvetítés"
        }
    },
    "integrations": {
        "title": "Integrációk",
        "social_media": "Social Media",
        "analytics": "Analitikák",
        "email_server": "Hírlevél"
    },
    "users": {
        "title": "Felhasználók",
        "admins": "Admin felhasználók",
        "rights": "Jogosultságok"
    },
    "personal_settings": {
        "title": "Személyes beállítások",
        "language": "Nyelv",
        "notifications": "Értesítések",
        "billing_information": "Számlázási adatok"
    },
    "miscellaneous": {
        "title": "Egyéb",
        "quickpick": "QuickPick QR menü",
        "giftcards": "Ajándékutalványok",
        "events": "Események",
        "experience_vouchers": "Élményutalványok",
    },
    "exports": {
        "title": "Exportok",
        "guest_database": "Exportok",
        "guest_database_title": "Vendégadatbázis",
        "guest_database_desc": "Az összes vendég neve, email címe és telefonszáma.",
        "newsletter_subscribers": "Hírlevél feliratkozók",
        "newsletter_subscribers_desc": "A hírlevélre feliratkozott vendégek neve, email címe és telefonszáma.",
        "reservations": "Foglalások",
        "reservations_desc": "Foglalások a kiválasztott időszakra (dátum, vendég, létszám, forrás, megjegyzés).",
        "reservations_with_guests": "Foglalások vendégadatokkal",
        "reservations_with_guests_desc": "Foglalások a vendégek teljes adataival együtt a kiválasztott időszakra.",
        "date_range": "Időszak",
        "download_xlsx": "Letöltés (Excel)",
        "download_xls": "Letöltés (Excel)",
        "download_csv": "Letöltés (CSV)",
        "dining_city_import": "DiningCity import",
        "dining_city_import_desc": "Foglalások importálása DiningCity rendszerből (.xls formátum).",
        "select_file": "Fájl kiválasztása",
        "import": "Importálás",
        "dining_city_import_success": "Az importálás sikeresen megtörtént.",
        "dining_city_import_error": "Az importálás során hiba történt. Kérjük, ellenőrizze a fájlt.",
    },
    "exports_imports": {
        "title": "Exportok / Importok",
    },
    "imports": {
        "title": "Importok",
        "dining_city": "DiningCity import",
        "guest_import_title": "Vendég import",
        "dining_city_import": "DiningCity import",
        "dining_city_import_desc": "Foglalások importálása DiningCity rendszerből (.xls formátum).",
        "select_file": "Fájl kiválasztása",
        "import": "Importálás",
        "dining_city_import_success": "Az importálás sikeresen megtörtént.",
        "dining_city_import_error": "Az importálás során hiba történt. Kérjük, ellenőrizze a fájlt.",
        "dining_city_import_details": "Importálás részletei",
        "dining_city_import_info": "A foglalási kódokat a létrejött foglalások megjegyzésében rögzítjük. A későbbi importokkor szükséges frissítéseket a mentett kód és a vendég telefonszáma alapján követjük, ezért arra kérjük, ezeket ne változtassa meg a helyes működés érdekében.",
        "guest_import": "Vendég import",
        "guest_import_desc": "A vendégek importálása .xlsx file csatolásával",
        "guest_import_fields": "Importáláskor elvárt oszlop nevek",
        "field_desc": "Az xlsx file minden füle, névtől függetlenül feldolgozásra kerül. A vendégadatbázisban már létező vendégek (egyező telefonszám vagy email alapján) kihagyásra kerülnek. Az oszlopok sorrendje nem számít, de hiányzó oszlop név esetén az import megszakad.",
        "guest_import_success": "Az importálás sikeresen megtörtént.",
        "guest_import_error": "Az importálás során hiba történt. Kérjük, ellenőrizze a fájlt.",
        "required": "kötelező",
        "optional": "opcionális"
    
    },
    "form_not_found": "Az űrlap nem található",
    "form_loading": "Betöltés...",
    "reservation_system": {
        "size_settings": "Méret beállítások",
        "max_restaurant_size": "Foglalható helyek száma",
        "size": "méret (fő)",
        "minimum_reservation_length": "Minimum foglalási hossz",
        "maximum_reservation_length": "Maximum foglalási hossz",
        "last_reservation_for_the_day": "Aznapi foglalás eddig lehetséges",
        "min_reservation_timeframe": "Minimum ennyivel előre kell foglalni",
        "automatic_approval_from": "Automatikus jóváhagyás (eddig)",
        "max_number_of_guests": "Max. csoportméret",
        "max_guests_at_time": "Hány fő érkezhet egy időpontra",
        "privacy_policy": "Foglalás utáni átirányítás",
        "turnaround_time": "Beeső vendég foglalásának hossza",
        "reserve_time_minutes": "Foglalási türelmi idő (perc)",
        "max_reservation_timeframe": "Előfoglalási idő (hónap)",
        "automatic_seating": "Vendég automatikus leültetése",
        "max_online_fill_rate": "Beeső vendégeknek fentartott kapacitás (%)",
        "enable_online_reservations": "Online foglalás engedélyezése",
        "enable_sms": "SMS üzenetek küldésének engedélyezése (havonta sms-enként kerül számlázára)",
        "enable_quarterly_hours": "Foglalási időpontok negyedóránként",
        "enable_waiting_list": "Várólista engedélyezése",
        "enable_custom_length_step": "Foglalás hossza 15 perces lépésekben (admin felületen)",
        "reservours_reservations": "Megjelenés a listázó oldalon",
        "enable_group_reservation": "Csoportos foglalás engedélyezése",
        "default_reservation_length": "Alapértelmezett foglalási hossz",
        "required_fields": "Kötelező foglalási mezők",
        "default_reservation_time": "Alapértelmezett foglalási idő",
        "allow_reservation_modification": "Vendég általi módosítás engedélyezése",
        "reservation_change_timeframe": "Eddig módosítható a foglalás az érkezés előtt (óra)",
        "allow_reservation_modification_info": [
            {
                "title": "Hol szerkesztheti a vendég a foglalását?",
                "items": [
                    "A foglalás után, a vendég email címére kiküldött visszaigazoló üzenetben"
                ]
            },
            {
                "title": "Mikor szerkesztheti a vendég a leadott foglalását?",
                "items": [
                    "Ha az adott foglalás nincs törölve vagy érkezettre állítva",
                    "Még elegendő idő van hátra a foglalás időpontjáig (a küszöbérték a jelölőnégyzet alatt állítható be)",
                    "Ha a foglaláshoz nem kapcsolódik foglalási díj"
                ]
            },
            {
                "title": "Mi történik, ha már általunk elfogadott foglalást módosítanak?",
                "items": [
                    "A módosított foglalásra is érvényesek a foglalásokra vonatkozó általános szabályok (pl. automatikus jóváhagyás, asztalhoz rendelés, előfoglalási idő) - ezek automatikusan alkalmazásra kerülnek a módosítás után."
                ]
            },
            {
                "title": "Nyomon követhető-e, hogy milyen módosítást végzett a vendég?",
                "items": [
                    "Ha egy foglalást módosított a vendég, akkor a foglalás szerkesztő felületen megjelenő 'Módosítások' fülön ellenőrizhető, hogy mikor és mit változtattak rajta, így visszakereshető a foglalás korábbi állapota is."
                ]
            }
        ],
        "on_manual_creation": "Admin felületen való rögzítéskor érvényes",
        "field_options": {
            "name": "Név",
            "name_phone": "Név és telefonszám",
            "name_email": "Név és email cím",
            "name_phone_email": "Név, telefonszám és email cím",
        }
    },
    "reservation_types": {
        "page_title": "Foglalási típusok",
        "info": "Az inside és outside típusoknál a megnevezés nem módosítható. A többi típusnál az összes mező szerkeszthető.",
        "name": "Megnevezés",
        "size": "Kapacitás",
        "priority": "Prioritás",
        "allcount": "Allcount",
        "approval_from": "Jóváhagyás ettől",
        "available": "Elérhető",
        "min_spending": "Min. fogyasztás",
        "min_spending_from": "Min. fogyasztás ettől",
        "min_reservation_size": "Min. vendég",
        "max_reservation_size": "Max. vendég",
        "available_from": "Elérhető-tól",
        "available_to": "Elérhető-ig",
        "add_type": "Új típus hozzáadása",
        "save_success": "Foglalási típusok sikeresen mentve.",
        "error_name_required": "A megnevezés megadása kötelező minden sornál.",
        "table_subscription_info": "Asztalokat tartalmazó előfizetésnél: egy foglalási típus csak akkor jelenik meg a vendégek számára, ha legalább egy asztalhoz hozzá van rendelve az adott típus. A típusnál fogadható maximális vendégszámot automatikusan az adott típushoz rendelt összes asztal kapacitásának összege határozza meg. Asztalok nélküli előfizetésnél (pl. Starter csomag) a típusnál beállított Kapacitás érték az irányadó.",
    },
    "reservation_length_rules": {
        "page_title": "Foglalási hossz beállítások",
        "title": "Egyéni foglalási hossz szabályok",
        "default_row_label": "Alapértelmezett",
        "add_rule": "Egyedi szabály hozzáadása",
        "guest_range_min": "Min vendégszám",
        "guest_range_max": "Max vendégszám",
        "default_length": "Alapértelmezett hossz",
        "min_length": "Min hossz",
        "max_length": "Max hossz",
        "minutes_suffix": "perc",
        "info": "Alapértelmezés szerint minden foglalás az Alapértelmezett sorban megadott hosszakat használja. Az egyéni szabályok lehetővé teszik, hogy vendégszám alapján más hosszakat alkalmazz. Ha egy foglalás vendégszáma egy szabály tartományába esik, az adott szabály hosszai érvényesülnek az alapértelmezett helyett.",
        "invalid_row_values": "Néhány sor értékei érvénytelenek: a min vendégszám nem haladhatja meg a max értéket, és a foglalás hosszára teljesülnie kell: min ≤ alap ≤ max.",
        "overlapping_guest_ranges": "Néhány sor vendégszám tartománya átfedésben van. Kérjük, javítsd az ütközéseket mentés előtt.",
        "save_success": "A foglalási hossz beállítások sikeresen mentve.",
    },
    "reservation_availability": {
        "add_new_custom_max_fill_rate": "Új egyedi max töltöttség hozzáadása",
        "hour_from": "Órától",
        "hour_to": "Óráig (beleértve)",
        "max_fill_rate": "Max töltöttség (%)",
        "valid_from": "Érvényesség kezdete",
        "valid_to": "Érvényesség vége",
        "delete_fill_rate": "Max töltöttség törlése",
        "delete_fill_rate_confirmation": "Biztosan törölni szeretnéd ezt a max töltöttséget?",
        "edit_fill_rates": "Max töltöttségek szerkesztése",
        "edit_fill_rate": "Max töltöttség szerkesztése",
    },
    "special_approval_rules": {
        "info": "A megadott időszakokra eső foglalások soha nem lesznek automatikusan jóváhagyva, azokat mindenképp kézzel kell elfogadni. Az időszak a foglalás kezdő időpontjára érvényes. A létszám azt jelenti, hogy legalább ennyi vendég esetén kell a kézi jóváhagyás (0 esetén minden foglalásra érvényes).",
        "add_new": "Új időszak hozzáadása",
        "existing_rules": "Beállított időszakok",
        "date_from": "Időszak kezdete",
        "date_to": "Időszak vége",
        "from_size": "Ettől a létszámtól",
        "delete_rule": "Időszak törlése",
        "delete_rule_confirmation": "Biztosan törölni szeretnéd ezt az időszakot? ({{from}} - {{to}})",
    },
    "reservation_source": {
        "add_new_custom_source": "Új egyedi forrás hozzáadása",
        "source_name": "Forrás neve",
        "delete_source": "Forrás törlése",
        "delete_source_confirmation": "Biztosan törölni szeretnéd ezt a forrást?",
    },
    "reservation_background": {
        "image_in_reservation_background": "Ez a kép jelenik meg a háttérben a foglalási felületen",
    },
    "auto_messages": {
        "message_type": "Üzenet típusa",
        "message": "Üzenet",
        "placeholder_tags": "Használható változók: {guest_name}, {reservation_date}, {reservation_start}, {reservation_end}, {reservation_size}, {reservation_type}. A használt változóknak tartalmaznia kell a {} zárójeleket.",
        "confirm": "Megerősített",
        "pending": "Rögzített, elfogadásra vár",
        "approve": "Admin - Elfogadás",
        "decline": "Admin - Elutasítás",
        "delete": "Admin - Törlés",
        "review": "Értékelés kérése",
        "self_delete": "Vendég törölte foglalását",
        "sms": "SMS",
        "min_date_warning_message": "Mai napra nem lehet foglalni üzenet",
        "no_timeslots_available_message": "Nincs elérhető időpont üzenet",
        "ai_generate": {
            "title": "Generálás AI-val",
            "style_label": "Stílus",
            "generate_button": "Generálás",
            "generating": "Generálás...",
            "overwrite_confirm": "Ez felülírja a jelenlegi üzenetet. Folytatod?",
            "styles": {
                "formal": "Magázódó",
                "informal": "Tegeződő",
                "elegant": "Elegáns",
                "casual": "Laza",
                "warm": "Meleg, személyes",
                "professional": "Professzionális",
                "luxury": "Prémium / Luxus",
                "concise": "Tömör"
            }
        }
    },
    "internal_events": {
        "message": "Üzenet",
    },
    "custom_messages": {
        "date": "Dátum",
        "type": "Típus",
        "message": "Üzenet",
        "delete_message": "Üzenet törlése",
        "delete_message_confirmation": "Biztosan törölni szeretnéd ezt az üzenetet?",
    },
    "acceptance_text": {
        "message": "Üzenet szövege",
        "acceptance_text_tip_title": "Mik az elfogadandó szövegek?",
        "acceptance_text_tip_text": "Az elfogadandó szövegek olyan üzenetek, amelyeket a vendégeknek el kell fogadniuk a foglalás befejezése előtt. Ezek az üzenetek tartalmazhatnak fontos információkat, szabályokat vagy feltételeket, amelyeket a vendégeknek tudomásul kell venniük a foglalás előtt.",
        "how_to_delete": 'A már létrehozott "Elfogadandó szövegeket" az Üzenetek -> Egyedi üzenetek alatt tudsz törölni, melyek "special" típusként jelennek meg.',
        "edit_acceptance_text": "Elfogadandó szöveg szerkesztése",
        "add_acceptance_text": "Elfogadandó szöveg hozzáadása"
    },
    "test_send": {
        "email_to_receive": "A teszt emaileket a bejelentkezett felhasználó email címére küldjük.",
        "automatic_acceptance": "Automatikus elfogadás",
        "automatic_pending": "Rögzített, elfogadásra vár",
        "automatic_confirm": "Jóváhagyás",
        "admin_decline": "Admin - Elutasítás",
        "admin_delete": "Admin - Törlés",
        "review_request": "Értékelés kérése",
        "self_delete": "Vendég törölte foglalását",
        "description": "Ha nincs beállítva egyedi üzenet, akkor nem küldünk teszt üzenetet.",
        "test_send_success": "Teszt üzenet sikeresen elküldve",
    },
    "reservours_info": {
        "reservours_link": "Étterem Reservours linkje",
        "booking_link_for_website": "Foglalási link a weboldalra",
        "booking_link_for_facebook": "Foglalási link a Facebookra",
        "booking_link_for_google": "Foglalási link a Google-re",
    },
    "restaurant_info": {
        "name": "Név",
        "telephone": "Telefon",
        "email": "Email",
        "country": "Ország",
        "city": "Város",
        "postal_code": "Irányítószám",
        "address": "Cím",
        "latitude": "Szélesség",
        "longitude": "Hosszúság",
        "click_on_the_map": "Kattints a térképre a koordináták pontos megadásához",
        "type": "Típus",
        "category": "Kategória",
        "price_category": "Árkategória",
        "tags": "Címkék",
        "website": "Weboldal",
        "menu_url": "Étlap link",
        "facebook_link": "Facebook link",
        "instagram_link": "Instagram link",
        "foodora_link": "Foodora link",
        "wolt_link": "Wolt link",
        "quickpick_link": "QuickPick link",
        "motto": "Mottó/Szlogen",
        "long_description": "Hosszú leírás",
        "specialties": "Specialitások",
        "specialty": {
            "breakfast": "Reggeli",
            "coffee": "Kávé",
            "dinner": "Vacsora",
            "drinks": "Italok",
            "lunch": "Ebéd",
            "delivery": "Házhozszállítás",
            "catering": "Catering",
            "groups": "Csoportok",
            "kids": "Gyerekek",
            "outdoor": "Kinti",
            "reserve": "Foglalás",
            "takeout": "Elvitelre",
            "waiter": "Felszolgáló",
            "walkins": "Foglalás nélkül is látogatható",
        },
        "types": {
            "restaurant": "Étterem",
            "cafe": "Kávézó",
            "bar": "Bár",
        },
        "bg": "Háttérkép",
        "restaurantimage": "Étterem kép",
        "voucher_background": "Ajándékutalvány háttérkép",
        "voucher_logo": "Ajándékutalvány logó",
        "delete_image": "Kép törlése",
        "image_delete_confirm": "Biztosan törölni szeretnéd ezt a képet?",
        "email_verification": {
            "not_verified": "Nem regisztrált",
            "pending": "Függőben",
            "verified": "Regisztrált",
            "verify": "Regisztráció",
            "resend": "Újraküldés",
            "revoke": "Visszavonás",
            "tooltip": "Csak regisztrált email címmel tudunk emailt küldeni a nevetekben. Egyéb esetben a vendégek a Reservours saját email címéről fogják megkapni az értesítéseket. Regisztrációra kattintva egy email-t fogtok kapni, és a benne lévő linkre kattintva tudjátok aktiválni a email címeteket. A regisztráció bármikor visszavonható. Módosulás esetén újra kell regisztrálni az új címet.",
            "delete_confirm": "Biztosan vissza szeretnéd vonni ezt az email regisztrációt? {{email}}",
        }
    },
    "social_media": {
        "no_available_channels": "Nincsenek elérhető csatornák",
        "integration_fee": "A social media integrációkkal kapcsolatos díjakról további részletek az ÁSZF-ben: ",
        "integration_guide": "Telepítési segítség Meta integrációkhoz a Tudásbázisban: ",
        "query_integration_credentials": "Bejelentkezési adatok lekérése Meta integrációhoz",
        "meta_credentials": "Meta bejelentkezési adatok",
    },
    "analytics": {
        "code": "Kód",
        "google_analytics_id": "Google Analytics Measurement ID",
        "facebook_pixel_id": "Facebook Pixel ID",
        "tiktok_pixel_id": "TikTok Pixel ID",
        "google_tag_manager_id": "Google Tag Manager ID",
        "tag_manager_disclaimer": "A partner ÁSZF értelmében a Tag Manageren keresztül kizárólag Facebook Pixel, Google Analytics és TikTok Pixel helyezhető el. Ennek megszegése esetén a GDPR nem megfelelőségből adódó károkért a teljes felelősség a partnert terheli.",
        "average_basket_value": "Átlagos kosárérték (Ft)",
    },
    "email_server": {
        "mailchimp": "Mailchimp",
        "api_key": "API kulcs",
        "api_key_instructions": "Az API kulcsod megtalálásához az alábbi linken találsz segítséget: https://mailchimp.com/help/about-api-keys/",
        "marketing_email_policy": "Marketing email szabályzat link",
        "mandatory_for_mailchimp": "Kötelező Mailchimphez",
        "select_mailing_list": "Válassz egy levelezőlistát",
        "mailerlite": "MailerLite",
        "mailerlite_api_key_instructions": "Az API kulcsot a MailerLite fiókodban az Integrations → API menüpont alatt találod.",
        "mailerlite_list_id_label": "Csoport ID (Group ID)",
        "mailerlite_list_id_instructions": "A csoport azonosítóját a MailerLite-ban a Subscribers → Groups menüpont alatt találod.",
        "brevo": "Brevo",
        "brevo_api_key_instructions": "Az API kulcsot a Brevo fiókodban a Settings → API Keys menüpont alatt találod.",
        "brevo_list_id_label": "Lista ID",
        "brevo_list_id_instructions": "A lista azonosítóját a Brevo adminban a lista neve mellett látod (numerikus).",
    },
    "admins": {
        "admin_users": "Admin felhasználók",
        "add_new_admin": "Új admin hozzáadása",
        "email": "Email",
        "name": "Név",
        "avatar": "Kép",
        "is_admin": "Adminisztrátor-e?",
        "email_verified": "Fiók aktiválva?",
        "right_type": "Jogosultság",
        "delete_admin": "Admin törlése",
        "delete_admin_confirmation": "Biztosan törölni szeretnéd ezt az adminisztrátort?",
        "rights": {
            "admin": "Adminisztrátor",
            "reservations_only": "Csak foglalások kezelése",
            "view_only": "Csak foglalások megtekintés",
            "reservations_and_settings": "Foglalások és beállítások kezelése",
        }
    },
    "notifications": {
        "guest_reservation": "Értesítés vendég általi foglalásról",
        "admin_add_reservation": "Értesítés admin felületen hozzáadott foglalásról",
        "admin_delete_reservation": "Értesítés admin felületen törölt foglalásról",
        "admin_cancel_reservation": "Értesítés admin felületen elutasított foglalásról",
        "data_autorefresh": "Adatok automatikus frissítése 5 percenként",
        "newsletter": "Hírlevél feliratkozás",
        "monthly_summary": "Havi összesítő kérése",
    },
    "blocked_times": {
        "valid_from": "Érvényesség kezdete",
        "valid_to": "Érvényesség vége",
        "type": {
            'blocked': 'Blokkolás',
            'closed': 'Zárva tartás',
        },
        'new_blocked_time': 'Új blokkolás hozzáadása',
        'day': 'Nap',
        'blocked_description': 'A foglalás kezdete nem eshet a blokkolt időtartamba, a blokkolt időtartamban úgy tűnik a felhasználónak, hogy nyitva van a vendéglátóhely, de nincs szabad hely.',
        'closed_description': 'Se a foglalás kezdete, se a vége nem eshet a blokkolt időtartamba.',
        'additional_description': 'Amennyiben teljes napra szeretnétek zárva lenni, úgy 11:00 előtt kezdődjön a zárva időszak és 21:00 után érjen véget!',
        'delete_blocked_time': 'Blokkolás törlése',
        'delete_blocked_time_confirmation': 'Biztosan törölni szeretnéd ezt a blokkolást?',
        "add_new_blocked_time": "Új blokkolás hozzáadása",
        "edit_blocked_time": "Blokkolás szerkesztése",
    },
    "shifts": {
        "new_shift": "Új műszak felvétele",
        "name": "Megnevezés",
        "lunch": "Ebéd",
        "from": "Kezdés",
        "to": "Vége",
        "interval": "Időtartam",
        "max_guests": "Max megengedett vendég százalék",
        "delete_shift": "Műszak törlése",
        "delete_shift_confirmation": "Biztosan törölni szeretnéd ezt a műszakot?",
        "overlapping_shift": "A műszakok átfedésben vannak, kérlek ellenőrizd a beállításokat!",
    },
    "room_blocks": {
        "name": "Megnevezés",
        "block_from": "Kezdés dátuma",
        "block_time": "Kezdés időpontja",
        "room": "Terem",
        "block_length": "Blokkolás hossza",
        "time_blocks": "Időblokk",
        "date_blocks": "Dátum blokk",
        "description": "Terem blokkolás esetén egy foglalásként fog megjelenni a foglalási listában, itt külön nincs feltüntetve!",
        "max_range_warning": "A dátum-intervallum legfeljebb 1 hét lehet.",
    },
    "opening_hours": {
        "opening_interval": "Nyitvatartás",
        "reservation_interval": "Első és utolsó foglalható időpont",
        "valid_interval": "Érvényesség",
        "validation": {
            "reservation_from_before_open_from": "Hiba a(z) {{weekday}} nap nyitvatartásánál: A foglalás kezdete ({{reservationFrom}}) nem lehet korábban, mint a nyitás ({{openFrom}}).",
            "reservation_from_after_open_to": "Hiba a(z) {{weekday}} nap nyitvatartásánál: A foglalás kezdete ({{reservationFrom}}) nem lehet a zárás ({{openTo}}) után vagy azzal egyidőben.",
            "reservation_to_not_after_open_from": "Hiba a(z) {{weekday}} nap nyitvatartásánál: A foglalás vége ({{reservationTo}}) nem lehet a nyitás ({{openFrom}}) előtt vagy azzal egyidőben.",
            "reservation_to_after_open_to": "Hiba a(z) {{weekday}} nap nyitvatartásánál: A foglalás vége ({{reservationTo}}) nem lehet a zárás ({{openTo}}) után vagy azzal egyidőben.",
            "reservation_interval_invalid": "Hiba a(z) {{weekday}} nap nyitvatartásánál: A foglalás kezdete ({{reservationFrom}}) nem lehet azonos a végével ({{reservationTo}}) vagy annál késóbb.",
            "reservation_to_after_midnight": "Hiba a(z) {{weekday}} nap nyitvatartásánál: A foglalás vége ({{reservationTo}}) nem lehet éjfélkor vagy azután.",
            "overlap_error": "Hiba a(z) {{weekday}} nap nyitvatartásánál: Átfedés a(z) {{validFrom1}} - {{validTo1}} ({{timeRange1}}) és a(z) {{validFrom2}} - {{validTo2}} ({{timeRange2}}) időszakok között ({{overlapType}}).",
            "overlap_type_open": "Nyitvatartási idők",
            "overlap_type_reservation": "Foglalási idők"
        },
        "custom_hours_note": "Egyedi nyitvatartás esetén a már meglévő nyitvatartás felül lesz írva a kiválasztott napokon. A módosítás nem visszavonható!",
        "service_break_note": "Szervíz szünet esetén a már meglévő nyitvatartásba beszúrunk egy szünetet, amikor az étterem nem elérhető és nem foglalható. A módosítás nem visszavonható!",
        "service_break_timerange": "Szervíz szünet időintervallum",
        "custom_hour_saved": "Egyedi nyitvatartás sikeresen mentve. A módosítás eredményét a Nyitvatartások beállítás menüpont alatt tudod ellenőrizni.",
        "service_break_saved": "Szervíz szünet sikeresen mentve. A módosítás eredményét a Nyitvatartások beállítás menüpont alatt tudod ellenőrizni.",
    },
    "rooms": {
        "room_name": "Terem neve",
        "priority": "Prioritás",
        "add_room": "Terem hozzáadása",
        "priority_duplicate": "Prioritás duplikáció",
    },
    "giftcards": {
        "giftcards_url": "Ajándékutalványok linkje",
        "min_value": "Minimum érték (Ft)",
        "max_value": "Maximum érték (Ft)",
        "step": "Lépés",
        "bg_color": "Háttérszín",
        "text_color": "Szövegszín",
        "enable_sales": "Eladás engedélyezése",
        "logo_url": "Logo kép",
        "bg_image_url": "Háttérkép",
        "valid_for_days": "Érvényesség napokban",
        "description": "Leírás",
        "experience_voucher_title": "Élményutalvány szerkesztése",
        "voucher_name": "Utalvány neve",
        "value": "Érték (Ft)",
        "active": "Eladás",
        "experience_vouchers_title": "Élményutalványok",
        "delete_experience_voucher": "Biztosan törölni szeretnéd ezt az élményutalványt?",
        "experience_voucher_deleted": "Élményutalvány sikeresen törölve",
        "no_experience_vouchers_yet": "Még nincsenek élményutalványok létrehozva"
    },
    "events": {
        "event_url": "Esemény linkje",
    },
    "billing": {
        "name": "Cégnév",
        "tax_code": "Adószám",
        "emails": "Email címek",
        "post_code": "Irányítószám",
        "city": "Város",
        "address": "Cím",
        "email_description": "A címek vesszővel legyenek elválasztva",
        "info1": "Figyelem: A számlázási adatok megváltoztatásával a következő havi számlázás a megadott adatok alapján történik.",
        "info2": "A ReservOurs mindig visszafelé számláz, így a céges adatokat csak a változás életbe lépése után módosítsa.",
        "billing_default_country": "Magyarország",
        "country": "Ország"
    },
    "labels": {
        "own_labels": "Saját címkék",
        "global_labels": "Globális címkék",
        "preview": "Előnézet",
        "priority": "Prioritás",
        "color": "Szín",
        "text": "Szöveg",
        "scope": "Kiterjedés",
        "add_label": "Új címke létrehozása",
        "visibility": "Láthatóság",
        "order": "Sorrend",
        "label_added": "Új címke sikeresen hozzáadva a listához. Ne felejtsd el elmenteni sorbarendezés után!",
        "label_scope": {
            "ALL": "Minden",
            "RESERVATION": "Foglalás",
            "GUEST": "Vendég",
        }
    },
    "tables": {
        "table_name": "Asztal neve",
        "table_size": "Asztal mérete",
        "table_type": "Asztal típusa",
        "fulfilling_order": "Feltöltési sorrend",
        "display_order": "Megjelenítési sorrend",
        "table_order_saved": "Új asztal sorrend sikeresen mentve",
    },
    "table_groups": {
        "available_tables": "Elérhető asztalok",
        "grouped_tables": "Csoportosított asztalok",
        "drop_tables_here": "Húzd ide az elérhető asztalok közül azokat, amiket csoportosítani szeretnél",
        "save_group": "Új csoport létrehozása",
        "table_group_name": "Asztalok nevei",
        "table_group_size": "Maximális méret",
        "min_size": "Minimális méret",
        "delete_group": "Csoport törlése",
        "no_groups": "Nincsenek megjeleníthető csoportok",
        "info_message": "A maximális méret módosításával egyedi méreteket adhatsz meg a csoportosított asztaloknak. Ezek sárga háttérrel fognak megjelenni.",
    },
    "google_reviews": {
        "search_google_business_by_name": "Keresés név alapján",
        "google_business_id": "Google azonosító",
        "google_business_id_placeholder": "Google azonosító megadása",
        "refresh_reviews": "Értékelések frissítése",
        "save_and_refresh": "Mentés és értékelések frissítése",
        "saved": "Új Google Business ID sikeresen lementve! Új értékelések töltődtek be.",
        "refreshed": "Új értékelések sikeresen letöltve!",
        "no_results": "Nincs találat",
    },
    "payment_schemes": {
        "info": "A foglalási díjak azt határozzák meg, hogy a vendégnek fizetnie kell-e a foglaláskor. A módosítás nem írja át a meglévő díjszabást: a régi inaktiválódik, és új sor jön létre - így a már leadott foglalások megtartják az eredeti díjat és lemondási határidőt.",
        "new_scheme": "Új foglalási díj",
        "edit_scheme": "Foglalási díj módosítása",
        "terms_accept_new": "Elolvastam és elfogadom a Partner ÁSZF foglalási díjakra vonatkozó rendelkezéseit.",
        "terms_info_new": "Tudomásul veszem, hogy a foglalási díj beszedésével, lemondásával és visszatérítésével járó feltételeket és költségeket a Partner ÁSZF tartalmazza, és hogy az itt beállított díj a mentés után leadott foglalásokra érvényes.",
        "terms_accept_edit": "Elfogadom a módosítás következményeit és a Partner ÁSZF foglalási díjakra vonatkozó rendelkezéseit.",
        "terms_info_edit": "Tudomásul veszem, hogy a mentéssel a jelenlegi díjszabás inaktiválódik, és új díjszabás jön létre: a már leadott foglalásokra továbbra is a korábbi díj és lemondási határidő érvényes, a módosítás csak az ezután leadott foglalásokra hat. A foglalási díjakkal járó költségeket és feltételeket a Partner ÁSZF tartalmazza.",
        "terms_link": "Partner ÁSZF",
        "scheme_saved": "Foglalási díj mentve",
        "scheme_not_found": "Ez a foglalási díj már nem létezik, a lista újratöltve.",
        "show_inactive": "Inaktív díjak megjelenítése",
        "reservation_type": "Foglalástípus",
        "default_type": "Alapértelmezett (minden típus)",
        "validity": "Érvényesség",
        "valid_from": "Érvényes -tól (a foglalás dátuma)",
        "valid_to": "Érvényes -ig",
        "valid_to_exclusive": "A vége kizárólagos: a megadott időpont már nem tartozik az érvényességbe.",
        "from_reservation_size": "Létszám -tól",
        "to_reservation_size": "Létszám -ig",
        "fee": "Díj",
        "fee_type": "Díj típusa",
        "fee_type_per_guest": "Fejenként",
        "fee_type_fixed": "Fix összeg",
        "fee_amount_per_guest": "Díj összege (fejenként)",
        "fee_amount_fixed": "Díj összege (teljes foglalásra)",
        "fee_per_guest_value": "{{amount}} {{currency}} / fő",
        "fee_fixed_value": "{{amount}} {{currency}} / foglalás (fix)",
        "cancellation": "Lemondás",
        "refund_scheme": "Lemondási séma",
        "refund_scheme_label": "{{hours}} órával a foglalás előtt",
        "currency": "Valuta",
        "payment_type": "Fizetési mód",
        "payment_types": {
            "immediate": "Azonnali fizetés"
        },
        "active": "Aktív",
        "priority_helper": "Ha több, egymást átfedő díjszabás is illeszkedik a foglalásra, a kisebb prioritású érvényesül.",
        "conflict_warning": "Figyelem: az alábbi aktív díjszabásokkal átfedés van ugyanazon a prioritáson, így nem meghatározott, melyik érvényesül. A mentés ettől még elvégezhető.",
        "error_valid_to": "Az érvényesség vége nem lehet korábbi vagy egyenlő a kezdetnél.",
        "error_from_reservation_size": "A létszám alsó határa legalább 1 legyen.",
        "error_to_reservation_size": "A létszám felső határa nem lehet kisebb az alsó határnál.",
        "error_fee_per_guest": "A díj nem lehet negatív, és egész számnak kell lennie.",
        "error_priority": "A prioritás nem lehet negatív, és egész számnak kell lennie.",
        "hours_from_reservation": "Órák a foglalástól",
        "reservation_size": "Foglalás méret",
        "priority": "Prioritás",
        "fee_per_guest": "Vendégenkénti díj",
        "fixed_price": "Fix ár",
        "refund_percentage": "Visszatérítési százalék",
        "reservation_fee_inactivation": "Foglalási díj inaktiválása",
        "reservation_fee_confirmation": "Inaktiválod ezt a foglalási díjat? A mostantól leadott foglalásokra nem fog vonatkozni, a meglévő foglalások nem változnak.",
    },
    "attributes": {
        "attributes": "Attribútumok",
        "categories": {
            "technology": "Technológia",
            "payment": "Fizetés",
            "experience": "Élmény",
            "events": "Események",
            "opening_hours": "Nyitvatartás",
            "safety": "Biztonság",
            "sustainability": "Fenntarthatóság",
            "location": "Elhelyezkedés",
            "services": "Szolgáltatások",
            "food_options": "Étel opciók",
            "drink_options": "Italválaszték",
            "accessibility": "Akadálymentesség",
        },
        "items": {
            "downtown": "Belvárosi elhelyezkedés",
            "waterfront": "Vízparti / tóparti / tengerparti",
            "near_public_transport": "Könnyen megközelíthető tömegközlekedéssel",
            "wheelchair_accessible": "Mozgáskorlátozottak számára akadálymentesített",
            "pet_friendly": "Állatbarát",
            "child_friendly": "Gyerekbarát",
            "terrace": "Terasz / kerthelyiség",
            "smoking_area": "Dohányzó részleg",
            "air_conditioning": "Légkondicionálás",
            "private_room": "Saját rendezvényterem",
            "takeaway": "Elvitelre is rendelhető",
            "delivery": "Házhozszállítás",
            "vegetarian": "Vegetáriánus opciók",
            "vegan": "Vegán opciók",
            "gluten_free": "Gluténmentes opciók",
            "halal": "Halal ételek",
            "organic": "Bio / organikus ételek",
            "local_ingredients": "Helyi alapanyagok",
            "craft_beer": "Kézműves sörök",
            "wine_selection": "Borválaszték",
            "cocktails": "Koktélok",
            "coffee_specialty": "Kávékülönlegességek",
            "non_alcoholic": "Alkoholmentes italválaszték",
            "online_reservation": "Online foglalási lehetőség",
            "qr_menu": "QR kódos étlap",
            "wifi": "Ingyenes WiFi",
            "mobile_payment": "Asztalnál fizetés mobilról",
            "contactless_payment": "Érintésmentes fizetés",
            "card_payment": "Bankkártyás fizetés",
            "szep_card": "SZÉP kártya elfogadás",
            "foreign_currency": "Külföldi valuta elfogadás",
            "amex": "American Express elfogadás",
            "live_music": "Élő zene",
            "karaoke": "Karaoke",
            "sports_screen": "Sportközvetítés",
            "dance_floor": "Tánctér/bulihelyszín",
            "view": "Panorámás kilátás",
            "wedding": "Esküvőhelyszín",
            "business_meetings": "Üzleti rendezvények",
            "birthday": "Szülinapi programok",
            "themed_nights": "Tematikus estek",
            "open_24h": "0-24 nyitva",
            "late_night": "Késő esti nyitvatartás",
            "seasonal": "Szezonális nyitvatartás",
            "holiday_open": "Ünnepnapokon is nyitva",
            "non_smoking": "Nem dohányzó",
            "allergen_info": "Allergén információk feltüntetése",
            "air_filters": "Légszűrő használata",
            "covid_measures": "COVID-19 biztonsági intézkedések",
            "eco_friendly": "Fenntartható működés",
            "recyclable_packaging": "Újrahasznosítható csomagolás",
            "food_waste_policy": "Ételhulladék csökkentés",
        }
    }
}

export default settingsHu;